import { Tabs } from '@base-ui/react/tabs'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface TabsPanelProps extends PartProps<Tabs.Panel.Props> {
  className?: string
}

function TabsPanel({ className, children, ...props }: TabsPanelProps) {
  return (
    <Tabs.Panel className={twMerge('relative flex-1', className)} {...props}>
      {children}
    </Tabs.Panel>
  )
}

export { TabsPanel }
